'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseMenuItem = require('../BaseMenuItem');

var _BaseMenuItem2 = _interopRequireDefault(_BaseMenuItem);

var _BaseMenuDivider = require('../BaseMenuDivider');

var _BaseMenuDivider2 = _interopRequireDefault(_BaseMenuDivider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseMenuSection = function BaseMenuSection(_ref) {
  var links = _ref.links,
      children = _ref.children,
      _onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-base-menu-section' },
    links ? links.map(function (link) {
      return _react2.default.createElement(
        _BaseMenuItem2.default,
        {
          key: link.display + '-' + link.href,
          href: link.href,
          newWindow: link.newWindow,
          onClick: function onClick() {
            return _onClick({
              destinationUrl: link.href,
              linkName: link.display,
              completion: true
            }, true);
          }
        },
        link.display
      );
    }) : null,
    children,
    _react2.default.createElement(_BaseMenuDivider2.default, null)
  );
};

BaseMenuSection.propTypes = {
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    display: _propTypes2.default.string,
    href: _propTypes2.default.string
  })),
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func
};

BaseMenuSection.defaultProps = {
  children: null,
  onClick: null
};

exports.default = BaseMenuSection;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/BaseMenuSection/BaseMenuSection.js
// module id = 266
// module chunks = 0